var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgrecommend2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 285,
  height: 140,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 70,
  height: 120,
  x: 108,
  y: 10,
  fill: "#fff",
  rx: 6
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 4,
  x: 129,
  y: 15,
  fill: "#F3F5F5",
  rx: 2
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 47.333,
  height: 71,
  x: 119,
  y: 33,
  fill: "#008060",
  opacity: 0.4,
  rx: 2
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 38.318,
  height: 38.318,
  x: 123.508,
  y: 36.381,
  fill: "#008060",
  rx: 2
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 32.682,
  height: 3.381,
  x: 123.508,
  y: 79.205,
  fill: "#008060",
  rx: 1.69
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 15.403,
  height: 3.423,
  x: 123.508,
  y: 86.053,
  fill: "#008060",
  rx: 1.711
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 22.249,
  height: 3.423,
  x: 123.508,
  y: 91.184,
  fill: "#008060",
  rx: 1.711
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 38,
  height: 57,
  x: 172,
  y: 43,
  fill: "#C1E2DA",
  rx: 2
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  width: 30.762,
  height: 30.762,
  x: 175.619,
  y: 45.715,
  fill: "#4DA791",
  rx: 1
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  width: 26.238,
  height: 2.714,
  x: 175.619,
  y: 80.096,
  fill: "#4DA791",
  rx: 1
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  width: 12.366,
  height: 2.748,
  x: 175.619,
  y: 85.592,
  fill: "#4DA791",
  rx: 1
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  width: 17.862,
  height: 2.748,
  x: 175.619,
  y: 89.711,
  fill: "#4DA791",
  rx: 1
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  width: 38,
  height: 57,
  x: 75,
  y: 43,
  fill: "#C1E2DA",
  rx: 2
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  width: 30.762,
  height: 30.762,
  x: 78.619,
  y: 45.715,
  fill: "#4DA791",
  rx: 1
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  width: 26.238,
  height: 2.714,
  x: 78.619,
  y: 80.096,
  fill: "#4DA791",
  rx: 1
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  width: 12.366,
  height: 2.748,
  x: 78.619,
  y: 85.592,
  fill: "#4DA791",
  rx: 1
})), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  width: 17.862,
  height: 2.748,
  x: 78.619,
  y: 89.711,
  fill: "#4DA791",
  rx: 1
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BABEC3",
  d: "M32.25 119.8c.248 0 .451.222.451.494v2.172c0 .271-.203.493-.452.493s-.452-.222-.452-.493v-2.172c0-.272.203-.494.452-.494M32.25 116c.248 0 .451.221.451.493v2.172c0 .272-.203.493-.452.493s-.452-.221-.452-.493v-2.172c0-.272.203-.493.452-.493M29.452 118.986h1.788c.249 0 .452.222.452.493 0 .272-.203.494-.452.494h-1.788c-.249 0-.452-.222-.452-.494 0-.271.203-.493.452-.493M33.258 118.986h1.788c.249 0 .452.222.452.493 0 .272-.203.494-.452.494h-1.788c-.249 0-.452-.222-.452-.494 0-.271.203-.493.452-.493M231.249 18.8c.249 0 .452.222.452.494v2.172c0 .271-.203.493-.452.493s-.452-.222-.452-.493v-2.172c0-.272.203-.494.452-.494M231.249 15c.249 0 .452.221.452.493v2.172c0 .271-.203.493-.452.493s-.452-.222-.452-.493v-2.172c0-.272.203-.493.452-.493M228.452 17.986h1.788c.249 0 .452.222.452.494 0 .271-.203.493-.452.493h-1.788c-.249 0-.452-.222-.452-.493 0-.272.203-.494.452-.494M232.258 17.986h1.788c.249 0 .452.222.452.494 0 .271-.203.493-.452.493h-1.788c-.249 0-.452-.222-.452-.493 0-.272.203-.494.452-.494M35 46.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0M218 121.5a1.5 1.5 0 1 0 2.999.001A1.5 1.5 0 0 0 218 121.5"
})));
export { SvgImgrecommend2 as ReactComponent };
export default __webpack_public_path__ + "static/media/img.recommend2.d3c39655.svg";